import { useEffect, useState } from 'react';
import { useStepsStore } from '../stores/StepsStore';

const Step_ShowOrder = () => {
  const { order_info, one_month_plans } = useStepsStore();

  const isSubscriptionItem = (variantID: number): boolean => {
    const plan = (one_month_plans ?? []).map(p => p.id).find((id) => id === variantID);
    if(plan) {
      return true;
    } else {
      return false;
    }
  }

  return (
    <div>
      <div className='margin-top'>
        <h2 className='ncf-title'>Your Order</h2>
        <span className='ncf-subtitle'>Details of your product and services</span>
      </div>
      {order_info?.items?.length ? order_info.items.filter(item => item.title.toLowerCase().indexOf('label') === -1).map((item) => (
        <div className="show-order">
          {item?.image_url ? <img width={'50px'} src={item?.image_url} /> : ''}
          <div className="show-order-info-box" >
            <span>{ isSubscriptionItem(item.variant_id) ? '1 Month Trial Monitoring Service' : item.title }</span>
          </div>
        </div>
      )) : ''}
    </div>
  );
};

export default Step_ShowOrder;